import { render, staticRenderFns } from "./COMMENT.vue?vue&type=template&id=5b32c64e&scoped=true&"
import script from "./COMMENT.vue?vue&type=script&lang=js&"
export * from "./COMMENT.vue?vue&type=script&lang=js&"
import style0 from "./COMMENT.vue?vue&type=style&index=0&id=5b32c64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b32c64e",
  null
  
)

export default component.exports